import { Sizes } from "../styles";

const DottedLine = ($) => {
	const adjustParagraphWidths = () => {
		const isMobile = `(max-width: ${Sizes.screens.medium})`;

		if (window.matchMedia(isMobile).matches) {
			$(".line").each(function () {
				const $left = $(this).find("p").first();
				const $right = $(this).find("p").last();

				// If the left paragraph exceeds 69 characters - set to 55% and exit
				if ($left.text().length > 69) {
					$left.css({ "min-width": "55%" });
					return;
				}

				// If the right paragraph exceeds 69 characters - set to 55% and exit
				if ($right.text().length > 69) {
					$right.css({ "min-width": "55%" });
					return;
				}

				const leftLineHeight = parseFloat(
					window.getComputedStyle($left[0]).lineHeight
				);
				const leftLines = Math.round($left[0].clientHeight / leftLineHeight);

				const rightLineHeight = parseFloat(
					window.getComputedStyle($right[0]).lineHeight
				);
				const rightLines = Math.round($right[0].clientHeight / rightLineHeight);

				if (leftLines > 1 && rightLines > 1) {
					$left.css({ "min-width": "43.5%" });
					$right.css({ "min-width": "43.5%" });
				} else if (leftLines > 1) {
					$right.css({ "min-width": "43.5%" });
					$left.css({ "min-width": "" });
				} else if (rightLines > 1) {
					$left.css({ "min-width": "43.5%" });
					$right.css({ "min-width": "" });
				} else {
					$left.css({ "min-width": "" });
					$right.css({ "min-width": "" });
				}
			});
		}
	};

	$(window).on("load resize", adjustParagraphWidths);
};

export default DottedLine;
